import React from "react";

export default function Header(){
    return (
        <section id="header">
            <h1>Tic Tac Game</h1>
        </section>
    )
}